const ON_CHANGE_DEBOUNCE_TIMER = 300;
const ALERT_MESSAGE_SHOW_TIMER = 3000; // 错误消息显示时间


const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update', // 购物车更新
  quantityUpdate: 'quantity-update', // 产品页面数量更新
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
